import { MutationTree } from 'vuex';
import { ProposalState } from './types';
import { SingleFilter } from '@/store/types';

export const mutations: MutationTree<ProposalState> = {
    /** Filters */

    /**
     * Set a query filter in state.
     *
     * @param state
     * @param key
     * @param value
     */
    setFilter(state, { key, value }: SingleFilter) {
        state.filters = { ...state.filters, [key]: value };
    },

    /**
     * Reset a single filter.
     *
     * @param state
     * @param key
     */
    resetFilter(state, key: string) {
        delete state.filters[key];
    },

    /**
     * Reset query filters.
     *
     * @param state
     */
    resetFilters(state) {
        state.filters = {};
    },
};
